import { CircleRsvpFragment } from '@modernhealth/circles-graphql/v2';
import { ComponentTextXSmall } from '@modernhealth/vital-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CircleSessionCard, CircleBaseSessionCard } from './CircleSessionCard';

export const CircleRsvpCard: React.FC<{
    rsvp: CircleRsvpFragment;
    isPrevious?: boolean;
    id: string;
}> = ({ rsvp, isPrevious, id }) => {
    const { t } = useTranslation('circles');

    if (rsvp.session.companyUuid) {
        const company = rsvp.session.companyName;

        return (
            <CircleBaseSessionCard
                id={id}
                to={`/private-circles/${rsvp.session.topic.slug}/registered/${rsvp.id}`}
                eyebrow={
                    <ComponentTextXSmall
                        fontColor="blue55"
                        css={{
                            fontWeight: 500,
                            textTransform: 'uppercase',
                        }}
                    >
                        {t('pages.company_circles.header', { company })}
                    </ComponentTextXSmall>
                }
                format={rsvp.session.topic.format}
                name={rsvp.session.topic.name}
                facilitators={rsvp.session.facilitators}
                startTime={rsvp.session.startTime}
            >
                {!isPrevious ? t(['cards.rsvp.cta', ''], { fallbackLng: [] }) : null}
            </CircleBaseSessionCard>
        );
    }

    return (
        <CircleSessionCard
            id={id}
            series={rsvp.session.topic.series}
            topic={rsvp.session.topic}
            session={rsvp.session}
            showAccess={false}
        >
            {!isPrevious ? t(['cards.rsvp.cta', ''], { fallbackLng: [] }) : null}
        </CircleSessionCard>
    );
};
